import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const sectionStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
};

export const sectionTitleStyles: SxProps<Theme> = {
    fontWeight: 600,
};

export const hintStyles: SxProps<Theme> = {
    color: 'text.secondary',
};

export const alertStyles: SxProps<Theme> = {
    borderRadius: 3,
};

export const listStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
};

/**
 * The hostname takes the room, the actions take what is left.
 *
 * Wraps rather than truncating: a hostname is the whole point of the row, and a clinic that
 * has just been given a long one should see it rather than an ellipsis.
 */
export const rowStyles = (theme: Theme): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
    px: 1.5,
    py: 1,
    borderRadius: 2,
    border: `1px solid ${theme.palette.divider}`,
});

export const hostnameStyles: SxProps<Theme> = {
    flexGrow: 1,
    minWidth: 0,
    wordBreak: 'break-all',
    fontFamily: 'monospace',
};

export const addRowStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
};

/**
 * Levels the button with the field rather than with the helper-text row beneath it.
 *
 * The row aligns tops, so all this needs is the field's own height -- a small outlined input
 * is 40px, while a default button is 46.5 and would hang below it. A nudge downwards was the
 * previous attempt and made it worse: it moved a box that was already too tall.
 *
 * `height` rather than `minHeight`, so the theme's coarse-pointer floor still wins on touch
 * and raises the button and the field to 44 together.
 */
export const addButtonStyles: SxProps<Theme> = {
    flexShrink: 0,
    height: 40,
};
